import { defineProvider } from '@nuxt/image/runtime'

interface ImageProviderOptions {
  baseURL?: string
}

/**
 * Nuxt Image provider для CDN изображений проекта.
 *
 * @param src - локальный путь или абсолютный HTTP(S) URL
 * @param baseURL - базовый CDN URL из Nuxt Image options
 * @returns URL исходного изображения или изображения на CDN
 */
export default defineProvider<ImageProviderOptions>({
  getImage(src, { baseURL }) {
    if (/^https?:\/\//i.test(src)) return { url: src }

    if (!baseURL) return { url: src }

    const normalizedBaseUrl = `${baseURL.replace(/\/$/, '')}/`
    const normalizedSource = src.replace(/^\//, '')

    return { url: `${normalizedBaseUrl}images/${normalizedSource}` }
  },
})
